var map = {
	"./fb.png": 4476,
	"./ig.png": 8085,
	"./menuBanner.png": 364,
	"./menuBirthdayButton_en.png": 7101,
	"./menuBirthdayButton_zh.png": 2906,
	"./menuBookButton.png": 7371,
	"./menuLogo_en.png": 6964,
	"./menuLogo_zh.png": 192,
	"./whiteBanner.png": 755
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56;